// ie 브라우저 호환성 관련 polyfill 추가
import '@babel/polyfill/dist/polyfill.min';
import Vue from 'vue';
import axios from 'axios';
import Bootstrap from 'bootstrap-vue';
import moment from 'moment';
import VueMomentJs from 'vue-momentjs';
import jQuery from 'jquery';
import Popper from 'popper.js';
import Fragment from 'vue-fragment';
//import UUID from 'vue-uuid';
import SdlControl from './components/common/control';
import SdlFilters from './filters';
import SdlDirectives from './directives';
import 'bootstrap/dist/js/bootstrap.min';
import App from './App';
import { addEntryPoint, router } from './router';
import store from './vuex/store';
import { i18n } from './i18n';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '../static/css/custom.css';
import '../static/css/sdl.css';
import '../static/css/simple-line-icons.css';
import '../static/css/vue-tabs.css';
import '../static/css/reward.css';
import api from './service';
import SDLUtil from '@/utils/SDLUtil';
import CustomDateTime from './utils/CustomDateTime';
import CustomRules from './utils/CustomRules';
import CustomExcelExtract from './utils/excelExtract';

// third party libraries used in bootstrap
global.jQuery = jQuery;
global.$ = jQuery;
global.Popper = Popper;

Vue.use(Bootstrap);
Vue.use(VueMomentJs, moment);
Vue.use(Fragment.Plugin);
Vue.use(SdlControl); // Additional components. common sdl
Vue.use(SdlFilters); // Additional filters. common sdl
Vue.use(SdlDirectives); // Additional directives. common sdl
//Vue.use(UUID);
Vue.use(CustomExcelExtract);

Vue.use(CustomDateTime);
Vue.mixin(CustomRules);
// Additional context
Vue.prototype.$CONTEXT = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$context = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$getVisited = SDLUtil.getTableVisited;
Vue.prototype.$setVisited = SDLUtil.setTableVisited;

Vue.config.productionTip = false;


if (SDLUtil.isMobile()) {
  console.log('mobile browser');
  router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error?code=410&redirect=${router.currentRoute.fullPath}` }).catch(() => {});
}

// axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('userToken'); // AS-IS
if (window.location.search.includes('?token=')) {
  const params = new URL(window.location.href).searchParams;
  const tokenStr = params.get('token');
  localStorage.setItem('userToken', `${tokenStr}`);
}
if (localStorage.getItem('adminToken') !== null && localStorage.getItem('adminToken') !== '') {
  axios.defaults.headers.common['original-user-id'] = SDLUtil.parseJwt(localStorage.getItem('adminToken')).userId;
}
// ie, edge https://stackoverflow.com/a/45835054
axios.defaults.headers.common.Pragma = 'no-cache';

axios.interceptors.request.use(
  config => {
    axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('userToken');
    axios.defaults.headers.common['last-access-time'] = localStorage.getItem('lastAccessTime');
    axios.defaults.headers.common['sap-country-code'] = localStorage.getItem('countryCode');
    // if (config.url.includes('rwd')) {
    // }

    if (Object.prototype.hasOwnProperty.call(config, 'data')) {
      if (Object.prototype.hasOwnProperty.call(config.data, 'labelJson')) {
        config.data.labelJson = JSON.stringify(config.data.labelJson);
      }
    }
    return config;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  response => {
    if (response.headers.date !== null && response.headers.date !== '') {
      localStorage.setItem('lastAccessTime', new Date(response.headers.date).getTime());
    }
    if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
      /*
        { code: '185', message: 'sdl.auth.message.user.notFound' },
        { code: '187', message: 'sdl.auth.message.token.retentionTimeout' }, 토큰시간 만료
        { code: '188', message: 'sdl.login.noUserInfoByIdEmail' },
        { code: '190', message: 'sdl.auth.message.user.notFound' },
        { code: '191', message: 'sdl.auth.message.user.waiting' },
        { code: '192', message: 'sdl.auth.message.user.inactive' },
        { code: '193', message: 'sdl.auth.message.user.deleted' },
        { code: '194', message: 'sdl.auth.message.token.invalid' }, 유효하지 않은 토큰
        { code: '195', message: 'sdl.auth.message.token.notFound' }, 토큰 없음
        { code: '199', message: 'sdl.auth.message.duplicate.login' }, 중복 로그인
        { code: '200', message: 'sdl.auth.message.access.limit.exceeded' },
        { code: '202', message: 'sdl.common.message.knoxLoginFail' },
        { code: '203', message: 'sdl.auth.message.user.exceed.password' },
       */
      store.commit('API_ERROR_CODE', String(response.data.error.code));
      const logoutCalled = store.getters.getLogoutCalled;
      if (logoutCalled || ['194', '195', '199', '200', '202', '203', '187'].includes(String(response.data.error.code))) {
        api.logout(); // userToken set ''
      }
      if (logoutCalled) {
        store.commit('LOGOUT_CALLED', false);
        router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login` }).catch(() => {});
        // document.location = `${SDLUtil.WEB_CONTEXT_PATH}/login`;
      } else { // 헤더의 로그아웃 클릭에 의한 요청이 아닌경우에도 토큰 만료, 중복로그인 등 발생함.
        // document.location = `${SDLUtil.WEB_CONTEXT_PATH}/error?code=${response.data.error.code}&redirect=${router.currentRoute.fullPath}`;
        response.response = {
          status: 9999,
        }; // 너무 많은 곳에서, err.response를 사용중이라서 맞춰줌.
        if (router.currentRoute.fullPath.includes('/error')) {
          router.push({ path: `${router.currentRoute.fullPath}` }).catch(() => {});
        } else if (response.data.error.code) {
          router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error?code=${response.data.error.code}&redirect=${router.currentRoute.fullPath}` }).catch(() => {});
        }
      }
      response.status = 9999;
      return Promise.reject(Object.assign(response, new Error(response.data.error.message)));
    }
    // 정상적임.
    store.commit('API_ERROR_CODE', '');
    store.commit('LOGOUT_CALLED', false);
    return response;
  },
  error => Promise.reject(error),
);

axios
  .get(`${SDLUtil.API_URL}/auth/noauth/all-menu-page-paths`)
  .then(({ data }) => {
    addEntryPoint(data).then(() => {
      new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
      }).$mount('#app');
    });
  })
  .catch(err => {
    console.warn('main.js all-menu-page-paths API error occur');
    console.error(err);
    window.location = `${SDLUtil.WEB_CONTEXT_PATH}/static/error.html`;
  });


/**
 * 20230316 not allow mobile access.
 */



// WEBPACK FOOTER //
// ./src/main.js